import { datadogRum } from "@datadog/browser-rum";

// HMAC sig / S3 presign params would explode cardinality and aren't needed to identify the image.
const sanitizeImageUrl = (url: string): string => url.split("?")[0] ?? url;

export const reportImageLoadError = (url: string | undefined, surface: string): void => {
  if (!url || url.startsWith("blob:") || url.startsWith("data:")) return;
  datadogRum.addAction("image_load_failed", {
    image_url: sanitizeImageUrl(url),
    surface,
  });
};
